import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang';
import './utils/index'
import noScroll from './directives/no-scroll';
// 初始化全局样式
import 'modern-css-reset/dist/reset.min.css';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
// // 引入chat组件
// import TDesignChat from '@tdesign-vue-next/chat';
// // 引入TDesign组件
// import TDesign from 'tdesign-vue-next';
// 引入少量全局样式变量
import 'tdesign-vue-next/es/style/index.css';

import $axios from './axios/create';

const app = createApp(App);


app.config.globalProperties.$axios = $axios;

app.use(ElementPlus, {
    locale: zhCn,
})
app.use(i18n)
app.use(store)
app.use(router)
app.directive('no-scroll', noScroll);
app.mount('#app')
